import jwt_decode from 'jwt-decode';

import { PLATFORMS } from '~/constants/platforms';
import { USER_ROLES } from '~/constants/user_roles';
import { JsonTokenDecoded } from '~/types/JsonTokenDecoded';

import { getMainRoleUser } from './getMainRoleUser';

export const getDefaultAppDomain = (
  accessToken: string,
  platform: PLATFORMS
) => {
  const decoded: JsonTokenDecoded = jwt_decode(accessToken);
  const userRoles = decoded.realm_access.roles;

  // Check if user has whalar-mode role OR (echo-agency AND foam-sourcing-agency)
  const hasWhalarMode = userRoles.includes(USER_ROLES.whalarMode);
  const hasEchoAgency = userRoles.includes(USER_ROLES.agency);
  const hasSourcingAgency = userRoles.includes(USER_ROLES.sourcingAgency);
  const hasSourcingBrand = userRoles.includes(USER_ROLES.sourcingBrand);

  // If user has whalar-mode role, redirect to WHALARMODE_DOMAIN regardless of the login route
  // This keeps backwards compatibility with the existing role and behaviour
  if (hasWhalarMode) {
    return `${process.env.NEXT_PUBLIC_WHALARMODE_DOMAIN}`;
  }

  // If user has echo-agency and either sourcing-agency or sourcing-brand role, redirect to the appropriate domain based on the platform
  if (hasEchoAgency && (hasSourcingAgency || hasSourcingBrand)) {
    if (platform === PLATFORMS.foam) {
      return `${process.env.NEXT_PUBLIC_WHALARMODE_DOMAIN}`;
    }
    return `${process.env.NEXT_PUBLIC_ORCA_DOMAIN}`;
  }

  // Fallback to original logic for other roles
  const mainRole = getMainRoleUser(accessToken, platform);

  switch (mainRole) {
    case USER_ROLES.backofficeAdmin:
    case USER_ROLES.backofficeWriter:
    case USER_ROLES.backofficeReader:
      return `${process.env.NEXT_PUBLIC_BACKOFFICE_DOMAIN}`;
    case USER_ROLES.agency:
    case USER_ROLES.brand:
    case USER_ROLES.brandUser:
      return `${process.env.NEXT_PUBLIC_ORCA_DOMAIN}`;
    case USER_ROLES.creatorEcho:
    case USER_ROLES.creatorFoam:
    case USER_ROLES.creatorManaged:
    case USER_ROLES.talentRep:
    default:
      return `${process.env.NEXT_PUBLIC_FOAM_DOMAIN}`;
  }
};
